import React from "react";
import Login from "../business/dto/login";

interface AuthContextType {
  jwt: any;
  signin: (login: Login, callback: VoidFunction) => void;
  signout: (callback: VoidFunction) => void;
}

export const AuthContext = React.createContext<AuthContextType>(null!);